<template>
  <div id="editUserInfo">
    <div class="head-title">
      <span class="head-text">商户信息</span>
    </div>
    <div class="box">
      <div class="form-box">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="商户账号">
            <el-input v-model="form.username" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="公司名称">
            <el-input v-model="form.company"></el-input>
          </el-form-item>
          <el-form-item label="客服电话">
            <el-input v-model="form.link_phone"></el-input>
          </el-form-item>
          <el-form-item label="公司地址">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item label="公司邮箱">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="总负责人">
            <el-input v-model="form.link_member"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="margin-left:160px;" type="primary" @click="onSubmit">确认修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      token: this.$cookies.get('shop_token'),
      form: {
        username: ''
      }
    }
  },
  created() {
    this.showUserInfo()
    this.$store.state.shop_top = 0;
    this.$store.state.shop_left = "信息设置";
  },
  methods: {
    showUserInfo() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
      }, 5000)
      var where = {
        token: this.token
      }
      this.axios
        .get(this.serve + 'shop/show_user_info', { params: where })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.form = data.data
          } else {
            this.$alerts.error('请求失败', this.$message)
          }
          loading.close()
        })
    },
    onSubmit() {
      let config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      const Qs = require('qs')
      var formData = this.form
      formData.token = this.token
      this.axios
        .post(this.serve + 'shop/editUserInfo', Qs.stringify(formData), config)
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.$alerts.success('信息修改成功', this.$message)
          } else {
            this.$alerts.error('信息修改失败', this.$message)
          }
        })
    }
  }
}
</script>
<style lang='scss'>
#editUserInfo {
  .head-title {
    width: 1060px;
    height: 46px;
    background: rgba(238, 238, 238, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 46px;
    text-align: left;
  }
  .head-text {
    margin-left: 16px;
  }
  .box {
    width: 1060px;
    height: 600px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .form-box {
    width: 500px;
  }
}
</style>